import { useEffect, useState } from 'react';

interface CounterHook {
  from: number;
  to: number;
  callback: () => void;
  step?: number;
  delay?: number;
}

function useCounter({
  from,
  to,
  callback,
  step = 1,
  delay = 1000,
}: CounterHook) {
  const [counter, setCounter] = useState(from);

  useEffect(() => {
    const interval = setInterval(() => {
      setCounter((prev) => {
        const newVal = from < to ? prev + step : prev - step;
        if (newVal === to) {
          setTimeout(() => {
            callback?.();
          });
        }
        return newVal;
      });
    }, delay);
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return counter;
}

export default useCounter;
